import { IntakeSentActions } from '../constants';
import { IntakeSentFormData } from '../../screens/General/screens/Students/screens/StudentInfo/tabs/Intake/components/IntakeSentForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';
import { MedicalReleaseOfInformationFormData } from '../../screens/Intake/screens/IntakeParent/components/MedicalReleaseOfInformationForm';
import { OfficePoliciesFormData } from '../../screens/Intake/screens/IntakeParent/components/OfficePoliciesForm';
import { InformedConsentForTestingFormData } from '../../screens/Intake/screens/IntakeParent/components/InformedConsentForTestingForm';
import { TelemedicineConsentFormData } from '../../screens/Intake/screens/IntakeParent/components/TelemedicineConsentForm';
import { TreatmentInformedConsentFormData } from '../../screens/Intake/screens/IntakeParent/components/TreatmentInformedConsentForm';
import { AbaIntakeFormData } from '../../screens/Intake/screens/IntakeParent/components/AbaIntakeForm';
import { ChildTreatmentQuestionnaireFormData } from '../../screens/Intake/screens/IntakeParent/components/ChildTreatmentQuestionnaireForm';
import { NeuropsychologyPatientFormData } from '../../screens/Intake/screens/IntakeParent/components/NeuropsychologyPatientForm';
import { ConsentTestingDoeCasesFormData } from '../../screens/Intake/screens/IntakeParent/components/ConsentTestingDoeCasesForm';
import { ReleaseOfHealthInformationPediatricianFormData } from '../../screens/Intake/screens/IntakeParent/components/ReleaseOfHealthInformationPediatricianForm';
import { ReleaseOfHealthInformationSchoolFormData } from '../../screens/Intake/screens/IntakeParent/components/ReleaseOfHealthInformationSchoolForm';
import { InformedConsentForVideoFormData } from '../../screens/Intake/screens/IntakeParent/components/InformedConsentForVideoForm';
import { WelcomePacketFormData } from '../../screens/Intake/screens/IntakeParent/components/WelcomePacketForm';
import { BriefBackgroundFormData } from '../../screens/Intake/screens/IntakeParent/components/BriefBackgroundForm';
import { TreatmentProcessFormData } from '../../screens/Intake/screens/IntakeParent/components/TreatmentProcessForm';
import {
    InformedExpectationFormData
} from '../../screens/Intake/screens/IntakeParent/components/InformedExpectationForm';
import { CreditCardFormData } from '../../screens/Intake/screens/IntakeParent/components/CreditCardForm';
import { HealthInformationFormData } from '../../screens/Intake/screens/IntakeParent/components/HealthInformationForm';
import { ConsentForBiFormData } from '../../screens/Intake/screens/IntakeParent/components/ConsentForBiForm';
export interface PersistIntakeSentAction {
    type: typeof IntakeSentActions.PERSIST_INTAKE_SENT;
    payload: {
        data: IntakeSentFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeSent(data: IntakeSentFormData, callbacks: SagaPromise<any>): PersistIntakeSentAction {
    return {
        type: IntakeSentActions.PERSIST_INTAKE_SENT,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeSent = (data: IntakeSentFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeSent(data, { resolve, reject }));
    });
};

export interface PersistIntakeMedicalReleaseAction {
    type: typeof IntakeSentActions.PERSIST_MEDICAL_RELEASE;
    payload: {
        data: MedicalReleaseOfInformationFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeMedicalRelease(
    data: MedicalReleaseOfInformationFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeMedicalReleaseAction {
    return {
        type: IntakeSentActions.PERSIST_MEDICAL_RELEASE,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeMedicalRelease = (data: MedicalReleaseOfInformationFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeMedicalRelease(data, { resolve, reject }));
    });
};

export interface PersistIntakeOfficePoliciesAction {
    type: typeof IntakeSentActions.PERSIST_OFFICE_POLICIES;
    payload: {
        data: OfficePoliciesFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeOfficePolicies(
    data: OfficePoliciesFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeOfficePoliciesAction {
    return {
        type: IntakeSentActions.PERSIST_OFFICE_POLICIES,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeOfficePolicies = (data: OfficePoliciesFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeOfficePolicies(data, { resolve, reject }));
    });
};

export interface PersistIntakeInformedConsentForTestingAction {
    type: typeof IntakeSentActions.PERSIST_INFORMED_CONSENT_FOR_TESTING;
    payload: {
        data: InformedConsentForTestingFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeInformedConsentForTesting(
    data: InformedConsentForTestingFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeInformedConsentForTestingAction {
    return {
        type: IntakeSentActions.PERSIST_INFORMED_CONSENT_FOR_TESTING,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeInformedConsentForTesting = (
    data: InformedConsentForTestingFormData,
    dispatch: Dispatch,
) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeInformedConsentForTesting(data, { resolve, reject }));
    });
};

export interface PersistIntakeInformedConsentForVideoAction {
    type: typeof IntakeSentActions.PERSIST_INFORMED_CONSENT_FOR_VIDEO;
    payload: {
        data: InformedConsentForVideoFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeInformedConsentForVideo(
    data: InformedConsentForVideoFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeInformedConsentForVideoAction {
    return {
        type: IntakeSentActions.PERSIST_INFORMED_CONSENT_FOR_VIDEO,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeInformedConsentForVideo = (
    data: InformedConsentForVideoFormData,
    dispatch: Dispatch,
) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeInformedConsentForVideo(data, { resolve, reject }));
    });
};

export interface PersistIntakeTelemedicineConsentAction {
    type: typeof IntakeSentActions.PERSIST_TELEMEDICINE_CONSENT;
    payload: {
        data: TelemedicineConsentFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeTelemedicineConsent(
    data: TelemedicineConsentFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeTelemedicineConsentAction {
    return {
        type: IntakeSentActions.PERSIST_TELEMEDICINE_CONSENT,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeTelemedicineConsent = (data: TelemedicineConsentFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeTelemedicineConsent(data, { resolve, reject }));
    });
};

export interface PersistIntakeConsentTestingDoeCasesAction {
    type: typeof IntakeSentActions.PERSIST_CONSENT_TESTING_DOE_CASES;
    payload: {
        data: ConsentTestingDoeCasesFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeConsentTestingDoeCases(
    data: ConsentTestingDoeCasesFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeConsentTestingDoeCasesAction {
    return {
        type: IntakeSentActions.PERSIST_CONSENT_TESTING_DOE_CASES,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeConsentTestingDoeCases = (data: ConsentTestingDoeCasesFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeConsentTestingDoeCases(data, { resolve, reject }));
    });
};

export interface PersistIntakeTreatmentInformedConsentAction {
    type: typeof IntakeSentActions.PERSIST_TREATMENT_INFORMED_CONSENT;
    payload: {
        data: TreatmentInformedConsentFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeTreatmentInformedConsent(
    data: TreatmentInformedConsentFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeTreatmentInformedConsentAction {
    return {
        type: IntakeSentActions.PERSIST_TREATMENT_INFORMED_CONSENT,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeTreatmentInformedConsent = (
    data: TreatmentInformedConsentFormData,
    dispatch: Dispatch,
) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeTreatmentInformedConsent(data, { resolve, reject }));
    });
};

export interface PersistIntakeAbaIntakeAction {
    type: typeof IntakeSentActions.PERSIST_ABA_INTAKE;
    payload: {
        data: AbaIntakeFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeAbaIntake(
    data: AbaIntakeFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeAbaIntakeAction {
    return {
        type: IntakeSentActions.PERSIST_ABA_INTAKE,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeAbaIntake = (data: AbaIntakeFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeAbaIntake(data, { resolve, reject }));
    });
};

export interface PersistIntakeChildTreatmentQuestionnaireAction {
    type: typeof IntakeSentActions.PERSIST_CHILD_TREATMENT_QUESTIONNAIRE;
    payload: {
        data: ChildTreatmentQuestionnaireFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeChildTreatmentQuestionnaire(
    data: ChildTreatmentQuestionnaireFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeChildTreatmentQuestionnaireAction {
    return {
        type: IntakeSentActions.PERSIST_CHILD_TREATMENT_QUESTIONNAIRE,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeChildTreatmentQuestionnaire = (
    data: ChildTreatmentQuestionnaireFormData,
    dispatch: Dispatch,
) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeChildTreatmentQuestionnaire(data, { resolve, reject }));
    });
};

export interface PersistIntakeNeuropsychologyPatientAction {
    type: typeof IntakeSentActions.PERSIST_NEUROPSYCHOLOGY_PATIENT;
    payload: {
        data: NeuropsychologyPatientFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeNeuropsychologyPatient(
    data: NeuropsychologyPatientFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeNeuropsychologyPatientAction {
    return {
        type: IntakeSentActions.PERSIST_NEUROPSYCHOLOGY_PATIENT,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeNeuropsychologyPatient = (data: NeuropsychologyPatientFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeNeuropsychologyPatient(data, { resolve, reject }));
    });
};

export interface PersistIntakeReleaseOfHealthInformationPediatricianAction {
    type: typeof IntakeSentActions.PERSIST_RELEASE_OF_HEALTH_INFORMATION_PEDIATRICIAN;
    payload: {
        data: ReleaseOfHealthInformationPediatricianFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeReleaseOfHealthInformationPediatrician(
    data: ReleaseOfHealthInformationPediatricianFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeReleaseOfHealthInformationPediatricianAction {
    return {
        type: IntakeSentActions.PERSIST_RELEASE_OF_HEALTH_INFORMATION_PEDIATRICIAN,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeReleaseOfHealthInformationPediatrician = (
    data: ReleaseOfHealthInformationPediatricianFormData,
    dispatch: Dispatch,
) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeReleaseOfHealthInformationPediatrician(data, { resolve, reject }));
    });
};

export interface PersistIntakeReleaseOfHealthInformationSchoolAction {
    type: typeof IntakeSentActions.PERSIST_RELEASE_OF_HEALTH_INFORMATION_SCHOOL;
    payload: {
        data: ReleaseOfHealthInformationSchoolFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeReleaseOfHealthInformationSchool(
    data: ReleaseOfHealthInformationSchoolFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeReleaseOfHealthInformationSchoolAction {
    return {
        type: IntakeSentActions.PERSIST_RELEASE_OF_HEALTH_INFORMATION_SCHOOL,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeReleaseOfHealthInformationSchool = (
    data: ReleaseOfHealthInformationSchoolFormData,
    dispatch: Dispatch,
) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeReleaseOfHealthInformationSchool(data, { resolve, reject }));
    });
};

export interface PersistIntakeWelcomePacketAction {
    type: typeof IntakeSentActions.PERSIST_WELCOME_PACKET;
    payload: {
        data: WelcomePacketFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeWelcomePacket(
    data: WelcomePacketFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeWelcomePacketAction {
    return {
        type: IntakeSentActions.PERSIST_WELCOME_PACKET,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeWelcomePacket = (data: WelcomePacketFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeWelcomePacket(data, { resolve, reject }));
    });
};

export interface PersistIntakeBriefBackgroundAction {
    type: typeof IntakeSentActions.PERSIST_BRIEF_BACKGROUND;
    payload: {
        data: BriefBackgroundFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeBriefBackground(
    data: BriefBackgroundFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeBriefBackgroundAction {
    return {
        type: IntakeSentActions.PERSIST_BRIEF_BACKGROUND,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeBriefBackground = (data: BriefBackgroundFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeBriefBackground(data, { resolve, reject }));
    });
};



export interface PersistIntakeTreatmentProcessAction {
    type: typeof IntakeSentActions.PERSIST_TREATMENT_PROCESS;
    payload: {
        data: TreatmentProcessFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeTreatmentProcess(
    data: TreatmentProcessFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeTreatmentProcessAction {
    return {
        type: IntakeSentActions.PERSIST_TREATMENT_PROCESS,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeTreatmentProcess = (data: TreatmentProcessFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeTreatmentProcess(data, { resolve, reject }));
    });
};

export interface PersistIntakeInformedExpectationAction {
    type: typeof IntakeSentActions.PERSIST_INFORMED_EXPECTATION;
    payload: {
        data: InformedExpectationFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeInformedExpectation(
    data: InformedExpectationFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeInformedExpectationAction {
    return {
        type: IntakeSentActions.PERSIST_INFORMED_EXPECTATION,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeInformedExpectation = (data: InformedExpectationFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeInformedExpectation(data, { resolve, reject }));
    });
};


export interface PersistIntakeCreditCardAction {
    type: typeof IntakeSentActions.PERSIST_CREDIT_CARD;
    payload: {
        data: CreditCardFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeCreditCard(
    data: CreditCardFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeCreditCardAction {
    return {
        type: IntakeSentActions.PERSIST_CREDIT_CARD,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeCreditCard = (data: CreditCardFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeCreditCard(data, { resolve, reject }));
    });
};


export interface PersistIntakeHealthInformationAction {
    type: typeof IntakeSentActions.PERSIST_HEALTH_INFORMATION;
    payload: {
        data: HealthInformationFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeHealthInformation(
    data: HealthInformationFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeHealthInformationAction {
    return {
        type: IntakeSentActions.PERSIST_HEALTH_INFORMATION,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeHealthInformation = (data: HealthInformationFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeHealthInformation(data, { resolve, reject }));
    });
};

export interface PersistIntakeConsentForBiAction {
    type: typeof IntakeSentActions.PERSIST_CONSENT_FOR_BI;
    payload: {
        data: ConsentForBiFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistIntakeConsentForBi(
    data: ConsentForBiFormData,
    callbacks: SagaPromise<any>,
): PersistIntakeConsentForBiAction {
    return {
        type: IntakeSentActions.PERSIST_CONSENT_FOR_BI,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistIntakeConsentForBi = (data: ConsentForBiFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistIntakeConsentForBi(data, { resolve, reject }));
    });
};

export type Actions =
    | PersistIntakeSentAction
    | PersistIntakeMedicalReleaseAction
    | PersistIntakeOfficePoliciesAction
    | PersistIntakeInformedConsentForTestingAction
    | PersistIntakeInformedConsentForVideoAction
    | PersistIntakeTelemedicineConsentAction
    | PersistIntakeConsentTestingDoeCasesAction
    | PersistIntakeTreatmentInformedConsentAction
    | PersistIntakeAbaIntakeAction
    | PersistIntakeChildTreatmentQuestionnaireAction
    | PersistIntakeReleaseOfHealthInformationPediatricianAction
    | PersistIntakeReleaseOfHealthInformationSchoolAction
    | PersistIntakeWelcomePacketAction
    | PersistIntakeBriefBackgroundAction
    | PersistIntakeTreatmentProcessAction
    | PersistIntakeInformedExpectationAction
    | PersistIntakeCreditCardAction
    | PersistIntakeHealthInformationAction
    | PersistIntakeConsentForBiAction;
